/*global Merlin*/
var _gaTracker = {};
jQuery(document).ready(function($) {
  // Init video banners
  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  var players = {};
  var numberVideo = $('.hero-slide .video-background').length;
  var numberLoadedVideo = 0;
  if (numberVideo) {

  } else {
    $('#go-hero-slide').removeClass('go-hero-slider-init');
  }
  window.onYouTubeIframeAPIReady = function() {
    $('.hero-slide .video-background').each(function() {
      var videoId = $(this).data('video_id');
      new YT.Player(this, {
        videoId: videoId,
        playerVars: {
          controls: 0,
          disablekb: 1,
          enablejsapi: 1,
          fs: 0,
          origin: location.origin,
          showinfo: 0,
          rel: 0
        },
        events: {
          onStateChange: function(event) {
            // Resume slide once video ends
            if (event.data === 0) {
              heroSlick.play();
              heroSlick.next();
            }
          },
          onReady: function(event) {
            var player = event.target;
            player.mute();
            // Play the video if it is current slide
            var $currentSlide = $(heroSlick.$slides[heroSlick.currentSlide]);
            if ($currentSlide.find('.video-background').attr('id') == player.a.id) {
              player.playVideo();
              heroSlick.pause();
            } else {
              // Preload the video
              player.seekTo(0);
              player.pauseVideo();
            }
            // save the player object
            players[player.a.id] = player;

            numberLoadedVideo++;
            if (numberLoadedVideo === numberVideo) {
              setTimeout(function() {
                $('#go-hero-slide').removeClass('go-hero-slider-init');
              }, 500);
            }
          }
        }
      });
    });
  };

  $('.videopopup').fancybox({
    type: 'iframe', //<--added
    maxWidth: 640,
    maxHeight: 370,
    fitToView: false,
    autoSize: false,
    closeClick: false,
    openEffect: 'none',
    closeEffect: 'none'
  });

  $('a.popup').fancybox();

  if (!('ontouchstart' in document.documentElement)) {
    document.documentElement.className += ' no-touch';
  }

  var $heroSlide = $('.hero-slide').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnDotsHover: true
  }).on('beforeChange', function(event, slick, currentIndex, nextIndex) {
    // Stop the current video
    $(slick.$slides[currentIndex]).find('.video-background').each(function(index, iframe) {
      var player = players[iframe.id];
      if (player) {
        player.seekTo(0);
        player.pauseVideo();
      }
    });
  }).on('afterChange', function(event, slick, currentIndex) {
    // Play the video
    $(slick.$slides[currentIndex]).find('.video-background').each(function(index, iframe) {
      var player = players[iframe.id];
      if (player) {
        player.playVideo();
        slick.pause();
      }
    });
  });
  if ($heroSlide.length) {
    var heroSlick = $heroSlide[0].slick;
    // Pause slider if the first slide is video
    if (
      null !== heroSlick.$slides &&
      heroSlick.$slides.length &&
      $(heroSlick.$slides[0]).find('.video-background').length
    ) {
      heroSlick.pause();
    }
  }

  $('.related-products ul').slick({
    dots: false,
    arrows: true,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplaySpeed: 10000,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $('.sc-news-slick').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 8000,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false
        }
      }
    ]
  });

  var loadMoreProduct = function(action) {
    action = action || 'load-more';
    var rangeValue = $('input[name="range_value"]').val();
    var currentCate = $('input[name="current_cate"]').val();
    var currentPage = $('input[name="current_product_list_page"]').val();
    var postPerPage = $('input[name="post_per_page"]').val();
    var orderby = $('input[name="list_orderby"]').val();
    var order = $('input[name="list_order"]').val();

    $.post(Merlin.ajaxUrl, {
      'security': Merlin.security,
      'action': 'load_product_list_filter',
      'rangeValue': rangeValue,
      'currentCate': currentCate,
      'currentPage': currentPage,
      'postPerPage': postPerPage,
      'orderby': orderby,
      'order': order
    }, function(response) {
      if (response.success === true) {
        if (action.toLowerCase() === 'load-more') {
          $('#product-list-container').append(response.data.content);
        } else {
          $('#product-list-container').html(response.data.content);
        }
        if (response.data.showLoadMore === true) {
          $('.sc-load-more').show().removeClass('disabled').text('Load more');
        } else {
          $('.sc-load-more').hide();
        }
        $('input[name="current_product_list_page"]').val(response.data.currentPage);
      }
    });
  };

  $('#product-filter-block .ul_list_filter li').on('click', function(e) {
    e.preventDefault();
    if ($(this).hasClass('active')) {
      $('input[name="range_value"]').val('');
      $(this).removeClass('active');
      $('input[name="current_product_list_page"]').val(1);
    } else {
      var rangeValue = $(this).find('input').val();
      $('#product-filter-block .ul_list_filter li.active').removeClass('active');
      $(this).addClass('active');
      $('input[name="range_value"]').val(rangeValue);
      $('input[name="current_product_list_page"]').val(1);
    }
    loadMoreProduct('filter');
  });

  $('.sc-load-more').on('click', function(e) {
    e.preventDefault();
    $(this).addClass('disabled').text('Loading...');
    loadMoreProduct('load-more');
  });

  // mobile menu
  $('nav#menu-mobile').mmenu({
    extensions: ['effect-slide-menu', 'pageshadow'],
    searchfield: {
      add: true,
      // search: false
    },
    counters: false,
    navbar: {
      title: 'Menu'
    },
    navbars: [
      {
        position: 'top',
        content: ['searchfield']
      }, {
        position: 'top',
        content: [
          'prev',
          'title',
          'close'
        ]
      }
    ]
  }, {
    searchfield: {
      // set the attributes for the FORM tag
      form: {
        name: 'gomerlin-form',
        action: '/',
        method: 'get'
      },
      input: {
        name: 's'
      },
      // add a submit-button
      submit: true
    }
  });
  $('.mm-navbar .mm-search').append('<input type="hidden" name="post_type" value="product" />');
  $('.mm-listview .headerRight > .mm-next').remove();
  $('.accordion-group').on('show.bs.collapse', function() {
    jQuery(this).parent().parent().find('.accordion-group').removeClass('active');
    jQuery(this).parent().parent().find('.accordion-group .accordion-body').removeClass('in');
    jQuery(this).addClass('active');

  });
  $('.accordion-group').on('hidden.bs.collapse', function() {
    jQuery(this).removeClass('active');
  });

  // selector
  $('.selectpicker').selectpicker({
    mobile: true
  });
  //datepicker
  $('.date-picker-gm').datetimepicker({
    //allowInputToggle: true,
    format: 'DD-MM-YYYY'
  });
  $('.open-datetimepicker').click(function(event) {
    event.preventDefault();
    $('.date-picker-gm').click();
  });

  // validate
  $.validate({
    validateOnBlur: false,
    showHelpOnFocus: false,
    addSuggestions: false,
    modules: 'date',
    form: 'form.validate,#commentform',
    scrollToTopOnError: true,
    borderColorOnError: '',
    errorMessagePosition: 'element',
    validateHiddenInputs: false,
    onValidate: function($form) {
    },
    onError: function($form) {
      $form.find('.error:first').focus();
    },
    onSuccess: function($form) {
      return true;
    },
    onElementValidate: function(valid, $el, $form, errorMess) {
    }
  });

  // product filter catergory
  $('.panle-gomerlin .panel-heading').click(function() {
    if (jQuery(this).parent().hasClass('active')) {
      jQuery(this).parent().removeClass('active');
    } else {
      jQuery(this).parent().parent().find('.panel').removeClass('active');
      jQuery(this).parent().addClass('active');
    }

  });

  $('.ellipsis').dotdotdot();
  jQuery('.question').hide();
  jQuery('.question1').show();
  // functin add select status
  jQuery('.options ul li a').click(function(e) {

    e.preventDefault();

    var dataScreen = jQuery(this).attr('data-option');
    if (typeof dataScreen !== typeof undefined && dataScreen !== false) {
      jQuery(this).closest('.options').find('a').removeClass('selected');
      jQuery(this).addClass('selected');
      var nextButton = jQuery(this).closest('.question').find('.next');
      optionClicked(nextButton, dataScreen);
    }

    //return false;
  });
  //optionClicked(dataScreen);
  // function click to next
  jQuery('.selector-nav .next').on('click', function(e) {
    e.preventDefault();
    var $thiz = jQuery(this);
    var data = $thiz.closest('.question').find('.options li a');

    if (!data.hasClass('selected')) {
      validationMessage();
      return false;
    } else {
      //	var stepFinal;
      data.each(function(val, key) {
        var step = jQuery(this).attr('data-step');
        if (jQuery(this).hasClass('selected') && typeof step !== 'undefined') {
          jQuery('.steps .step' + step).addClass('selected');
        }
      });
    }
  });

  var stepCount = 0;

  function updatePercentageStep(stepId, next) {
    var stepPercentage = 0;
    if (next) {
      stepCount += 1;
    } else {
      stepCount = 0 <= (stepCount - 1) ? (stepCount - 1) : 0;
    }

    if ($(stepId).find('.next').length) {
      for (var i = 1; i <= stepCount; i++) {
        stepPercentage += (100 - stepPercentage) / 2;
      }
      $('#step-recommend').hide();
    } else {
      stepPercentage = 100;
      $('#step-recommend').show();
    }

    $('#step-progress-bar').css({
      'width': Math.round(stepPercentage) + '%'
    });

    if (stepPercentage) {
      $('#step-progress-bar-txt').html(Math.round(stepPercentage) + '% Complete');
      $('#product-progress-selector').removeClass('progress-zero');
    } else {
      $('#step-progress-bar-txt').html('');
      $('#product-progress-selector').addClass('progress-zero');
    }
  }

  function optionClicked(nextButton, opt) {
    jQuery(nextButton).unbind('click').on('click', function(e) {
      e.preventDefault();
      if (opt == null || typeof opt === 'undefined') {
        validationMessage();
        return false;
      } else {
        jQuery('.question').hide();
        jQuery('#' + opt).show();

        updatePercentageStep('#' + opt, true);
      }

    });

  }

  // click to back button

  jQuery('.selector-nav .back').on('click', function(e) {
    e.preventDefault();
    var screen = jQuery(this).attr('href');
    //alert(screen);
    jQuery('.question').hide();
    jQuery(screen).show();
    var step = jQuery(this).attr('data-step');
    if (typeof step !== typeof undefined && step !== false) {
      jQuery('.steps .step' + step).removeClass('selected');
    }

    updatePercentageStep(screen, false);
  });

  //script for product selector

  /*jQuery(".question").hide();
  jQuery(".question1").show();

  var question = 1;
  var q1 = "";
  var q2 = "";
  var q3 = "";
  var result = "";
  selectedClass = "selected";
  pTitle = "";
  pImg = "";
  pLink = "";

  var selectedProduct = [];

  var product1 = [ "SilentDrive BBU", "http://gomerlin.project-staging.com/wp-content/themes/scalia-child/assets/images/Merlin.png", "#",'The ultimate sectional door opener - NOW WITH 7 YEAR WARRANTY'];
  var product2 = [ "SilentDrive", "http://gomerlin.project-staging.com/wp-content/themes/scalia-child/assets/images/Merlin.png", "#",'The ultimate sectional door opener - NOW WITH 7 YEAR WARRANTY' ];
  var product3 = [ "QuietDrive", "http://gomerlin.project-staging.com/wp-content/themes/scalia-child/assets/images/Merlin.png", "#" ,'The ultimate sectional door opener - NOW WITH 7 YEAR WARRANTY'];
  var product4 = [ "WhisperDrive", "http://gomerlin.project-staging.com/wp-content/themes/scalia-child/assets/images/Merlin.png", "#" ,'The ultimate sectional door opener - NOW WITH 7 YEAR WARRANTY'];
  var product5 = [ "Tiltmaster", "http://gomerlin.project-staging.com/wp-content/themes/scalia-child/assets/images/Merlin.png", "#" ,'The ultimate sectional door opener - NOW WITH 7 YEAR WARRANTY'];
  var product6 = [ "PowerAce", "http://gomerlin.project-staging.com/wp-content/themes/scalia-child/assets/images/Merlin.png", "#",'The ultimate sectional door opener - NOW WITH 7 YEAR WARRANTY'];
  var noMatch = [ "NO MATCH FOUND", "", "" ];


  jQuery(".options ul li a").click(function(){
    optionClicked(this);
    return false;
  });
  function optionClicked(opt){
    switch(question){
      case 1:
        q1 = jQuery(opt).attr("data-option");
        break;
      case 2:
        q2 = jQuery(opt).attr("data-option");
        break;
      case 3:
        q3 = jQuery(opt).attr("data-option");
        break;
    }
    jQuery(".question" + question + "  li a").removeClass(selectedClass);
    jQuery(opt).addClass(selectedClass);
  }


  jQuery(".next").click(function(){
    switch(question){
      case 1:
        if(q1 != ""){
          if(q1 == "tilt-garage-door"){
            getResult();
          }
          else{
            changeQuestion(2);
          }
        }
        else{
          validationMessage();
        }
        break;
      case 2:
        if(q2 != ""){
          changeQuestion(3);
        }
        else{
          validationMessage();
        }
        break;
      case 3:
        if(q3 != ""){
          getResult();
        }
        else{
          validationMessage();
        }
        break;
    }
    return false;
  });*/

  function changeQuestion(id) {
    question = id;
    jQuery('.question').hide();
    jQuery('.step').removeClass(selectedClass);
    jQuery('.step' + question).addClass(selectedClass);
    jQuery('.question' + question).show();
  }

  function validationMessage() {
    alert('Please select an option!');
  }

  function getResult() {
    // ajax query
    $.post(Merlin.ajaxUrl, {
      'security': Merlin.security,
      'action': 'query_product_selector',
      'garage_door': q1,
      'battery_backup': q2,
      'warranty': q3
    }, function(response) {
      jQuery('.questions').hide();
      jQuery('.steps').hide();
      jQuery('.step').removeClass(selectedClass);
      jQuery('.result').show();

      if (true === response.success) {
        jQuery('#result-container').html(response.data.html);
      }
    });

  }

  jQuery('.restart').click(function() {
    location.reload();
    return false;
  });

  jQuery('.back').click(function() {
    changeQuestion(question - 1);
    return false;
  });

  /* Warranty Registration Form */

  var updateDoorSizeSelect = function() {
    var doorTypeSelect = $('select[name="door_type"]');
    var doorSizeSelect = $('select[name="door_size"]').val();
    if (typeof doorSizeSelect != 'undefined' && doorSizeSelect != '' && doorSizeSelect != 'None') {
      doorTypeSelect.removeAttr('disabled');
      doorTypeSelect.parent().removeClass('disabled');
      doorTypeSelect.parent().find('.disabled').removeClass('disabled');
    } else {
      doorTypeSelect.val('None').change();
      doorTypeSelect.attr('disabled', 'disabled');
    }
  };

  updateDoorSizeSelect();

  $('select[name="merlin_fitted"]').on('change', function(e) {
    updateDoorSizeSelect();
  });

  $('select[name="door_size"]').on('change', function(e) {
    updateDoorSizeSelect();
  });

  $(document.body).bind('added_to_cart updated_wc_div', function(event, fragments, cart_hash) {
    // ajax query
    $.post(Merlin.ajaxUrl, {
      'security': Merlin.security,
      'action': 'get_cart_total'
    }, function(response) {
      $('.cart-header .merlin-badge .badge').text(response.data.number);
    });
  });

  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover({trigger: 'hover'});

  function loadMoreFaq() {
    var button = $('#faq-list-load-more').first();
    var page = parseInt(button.attr('data-page'));
    var perPage = parseInt(button.attr('data-per-page'));
    var postId = parseInt(button.attr('data-post-id'));

    $.post(Merlin.ajaxUrl, {
      'security': Merlin.security,
      'action': 'load_more_faq',
      'page': page,
      'per_page': perPage,
      'post_id': postId
    }, function(response) {
      if (!response.next) {
        $('#faq-list-load-more-wrap').hide();
      } else {
        button.attr('data-page', page + 1);
      }

      $(response.html).appendTo('#faq-list-content').hide().fadeIn('slow');

      // init VC_toggle event
      if (response.ids.length) {
        setTimeout(function() {
          $('#' + response.ids.join(' .vc_toggle_title, #') + ' .vc_toggle_title').on('click', initVcToggle);
        }, 400);
      }
    });
  }

  if ($('#faq-list').length) {
    $('.sc_accordion').each(function(index) {
      if ($(this).attr('id') !== 'faq-list') {
        $(this).hide();
      }
    });
    if ($('#faq-list-load-more').length) {
      $('#faq-list-load-more').first().click(function(e) {
        e.preventDefault();
        loadMoreFaq();
      });
    }
  }

  function initVcToggle(e) {
    e && e.preventDefault && e.preventDefault();
    var title = jQuery(this), element = title.closest('.vc_toggle'), content = element.find('.vc_toggle_content');
    element.hasClass('vc_toggle_active') ? content.slideUp({
      duration: 300, complete: function() {
        element.removeClass('vc_toggle_active');
      }
    }) : content.slideDown({
      duration: 300, complete: function() {
        element.addClass('vc_toggle_active');
      }
    });
  }

  // Auto-complete postcode by suburb and state
  /*
  $('form#check-out input#billing_postcode').on('change', function() {
    var $this = $(this);
    var $val = $this.val().trim();
    if ($val.length === 4) {
      $.post(Merlin.ajaxUrl, {
        'action': 'load_suburb',
        'postcode': $val
      }, function(response) {
        var data = response.data;
        if (data.suburb && data.state) {
          $('form#check-out input#billing_city').val(data.suburb);
          $('form#check-out select#billing_state').val(data.state);
        }
      });
    }
  });
  */

  // Register listener
  _gaTracker = {
    ga_register_event: function(category, label, value) {
      ga('send', 'event', category, label, value);
    },
    woo_create_account: function() {
      if ($('#createaccount').prop('checked')) {
        console.log('Account creations via Woo');
        this.ga_register_event('Account creation', 'click', 'Account creations via Woo');
      }
    },
    pdf_download: function(element) {
      var title = $(element).data('title');
      console.log('PDF downloads', title);
      this.ga_register_event('PDF download', 'click', title);
    },
    enquiry_now: function() {
      console.log('Enquire Now Form');
      this.ga_register_event('Enquire Now Form', 'click', 'Enquire Now Form');
    },
    add_to_cart: function(element) {
      var title = $(element).data('title');
      var href = $(element).attr('href');
      if (href.indexOf('enquire') === -1) {
        console.log('Shop journey basic add to cart: ', title);
        this.ga_register_event('Shop journey basic add to cart', 'click', title);
      } else {
        console.log('Enquire Now link on the product: ', title);
        this.ga_register_event('Enquire Now link on the product', 'click', title);
      }
    },
    recommendation_click: function(title) {
      console.log('Product selector product recommendation link click');
      this.ga_register_event('Product recommendation link click', 'click', title);
    },
    dealer_portal_click: function() {
      console.log('Dealer Portal link click');
      this.ga_register_event('Dealer Portal link click', 'click', 'Dealer Portal link click');
    },
    mail_to_link_click: function() {
      console.log('Mail to links link');
      this.ga_register_event('Mail to links link', 'click', 'Mail to links link');
    },
    hero_link_click: function() {
      console.log('Hero banner clicks link');
      this.ga_register_event('Hero banner clicks link', 'click', 'Hero banner clicks link');
    }
  };

  function scrollToMainContent(animate) {
    var top = jQuery('#main-content').offset().top;

    if ($('#site-header-wrapper').is(':visible')) {
      top = top - 75;
    }
    if (animate !== undefined) {
      $('body, html').animate({
        scrollTop: top
      }, 300);
    } else {
      setTimeout(function() {
        $('body, html').scrollTop(top);
      }, 500);
    }
  }

  if (goToMainContent !== undefined && goToMainContent) {
    scrollToMainContent();
  }

  $('.page-id-14517 .hero-slide .hero-item .txt-hero .button a').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    scrollToMainContent(true);
  });

  // bind Dealer Portal link click event
  $('#top-area .top-area-contacts-child > a').on('click', function(e) {
    var $this = $(this);
    if ($this.html().indexOf('Dealer') > -1) {
      _gaTracker.dealer_portal_click();
    }
  });

  // Product recommendation
  $('.product_selector .questions .question .options.centered.last-node > a').on('click', function(e) {
    var $this = $(this);
    var title = $this.find('p').html();
    _gaTracker.recommendation_click(title);
  });

  // G Squared custom scripts

  var adminBarHeight = 0;
  var body = $('body');
  var header = $('.header');
  var screen_admin_min = 783;

  // Window events
  var onWindowEvents = function(foo, isReady, isLoad, isResize, isScroll) {
    if (isReady) {
      $(document).ready(foo);
    }

    if (isLoad) {
      $(window).bind('load', foo);
    }

    if (isResize) {
      var throttleResizing = _.throttle(foo, 100);
      $(window).bind('resize', throttleResizing);
    }

    if (isScroll) {
      var throttleScroll = _.throttle(foo, 10);
      $(window).bind('scroll', throttleScroll);
    }
  };

  // Detecting clicking out of element
  var detectClickOutOf = function(el, foo) {
    $(document).mouseup(function(e) {
      var j = $(el);
      if (j.length && !j.is(e.target) && j.has(e.target).length === 0) {
        foo();
      }
    });
  };

  // Calculate admin bar
  if (body.hasClass('admin-bar')) {
    if ($(window).width() > screen_admin_min) {
      adminBarHeight = 32;
    } else {
      adminBarHeight = 46;
    }
  }

  // Go to element
  $.fn.goToElement = function(offset) {
    offset = 80;
    if ($(this).length) {
      var offsetTop = $(this).offset().top;
      if ($(window).scrollTop() > offsetTop) {
        offset += 20;// Extra space for Scrolling up
      }

      var args = {
        scrollTop: (offsetTop - adminBarHeight - offset)
      };
      $('html, body').animate(args, 'fast');
    }
    return this;
  };

  body.on('click', '.anchor-link', function(e) {
    var _this = $(this);
    if (0 === _this.attr('href').indexOf('#')) {
      e.preventDefault();
      $(_this.attr('href')).goToElement();
    }
  });

  // Balance elements
  var balanceElements = function(container, clr, gapDelta) {
    clr = (typeof clr !== 'undefined' ? clr : false);
    gapDelta = (typeof gapDelta !== 'undefined' ? gapDelta : 10);
    var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = [],
      el,
      currentDiv,
      topPosition = 0;
    var c = $(container).filter(':visible');
    if (!c.length) {
      return false;
    }
    if (!clr) {
      c.css('height', 'auto');
    } else {
      c.removeAttr('style');
    }
    c.each(function() {
      el = $(this);
      topPosition = el.offset().top;
      if ((currentRowStart < (topPosition + gapDelta)) && (currentRowStart > (topPosition - gapDelta))) {
        rowDivs.push(el);
        currentTallest = (currentTallest < el.outerHeight()) ? (el.outerHeight()) : (currentTallest);
      } else {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].css('height', currentTallest + 'px');
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPosition;
        currentTallest = el.outerHeight();
        rowDivs.push(el);
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].css('height', currentTallest + 'px');
      }
    });
    return true;
  };

  onWindowEvents(function() {balanceElements($('.balance-elements'), false, 50);}, 1, 1, 1, 0);

  // Trigger on Load more
  var woofAjaxDone = function() {
    setTimeout(function() {
      balanceElements($('.balance-elements'), false, 50);
    }, 100);
  };

  $(document).on('berocket_ajax_products_infinite_loaded', woofAjaxDone);

  // Add plus/minus button on cart ajax update
  // Quantity buttons
  $(document.body).on('updated_wc_div', function() {
    $('div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)').addClass('buttons_added').append('<button type="button" class="plus" >+</button>').prepend('<button type="button" class="minus" >-</button>');
  });

  // On checkout submit
  $('form.checkout').on('checkout_place_order_bpoint', function() {
    setTimeout(function() {
      if (!$('.woocommerce-error').length) {
        $('.processing-payment').show();
      }
    }, 500);
  });
  body.on('checkout_error', function() {
    $('.processing-payment').hide();
  });

  // Open review tab
  $(document).on('click', '.woocommerce-review-link', function() {
    $('.resp-tab-active').removeClass('resp-tab-active');
    $('.reviews_tab').trigger('click');
  });

  // Scroll up when change step on checkout
  $('.woocommerce-button-next-step').click(function(e) {
    setTimeout(function() {
      $('#check-out').goToElement();
    }, 500);
  });

  // Lazy load Youtube
  var youtube = document.querySelectorAll('.youtube');
  for (var i = 0; i < youtube.length; i++) {
    var source = 'https://img.youtube.com/vi/' + youtube[i].dataset.embed + '/maxresdefault.jpg';

    var image = new Image();
    image.src = source;
    image.addEventListener('load', function() {
      youtube[i].appendChild(image);
    }(i));

    youtube[i].addEventListener('click', function() {

      var iframe = document.createElement('iframe');

      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + this.dataset.embed + '?rel=0&showinfo=0&autoplay=1');

      this.innerHTML = '';
      this.appendChild(iframe);
    });
  }

  // Play video in modal
  var modalVideo = $('#modal-video');
  $(document).on('click', '.play-modal-video', function(e) {
    e.preventDefault();

    var _this = $(this);
    var videoId = _this.data('youtube-id');
    var videoTitle = _this.data('youtube-title');

    modalVideo.find('iframe').attr('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&info=0&rel=0&showinfo=0&modestbranding=1');
    modalVideo.find('.modal-title').text(videoTitle);
  });

  modalVideo.on('hidden.bs.modal', function() {
    modalVideo.find('iframe').attr('src', '');
    modalVideo.find('.modal-title').text('');
  });
});
